export const addApolloScript = () => {
  if (!process.env.REACT_APP_APOLLO_APP_ID) return;

  const nocache = Math.random()
    .toString(36)
    .substring(7);
  const script = document.createElement("script");

  script.id = "apollo-tracking-script";
  script.src = `https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=${nocache}`;
  script.async = true;
  script.defer = true;

  script.onload = function() {
    if (window.trackingFunctions) {
      window.trackingFunctions.onLoad({ appId: process.env.REACT_APP_APOLLO_APP_ID });
    }
  };

  document.head.appendChild(script);
};
export const removeApolloScript = () => {
  const script = document.getElementById("apollo-tracking-script");
  if (script) {
    document.head.removeChild(script);
  }
};

// handle Mouse flow Script
// export const addMouseflowScript = isValidURL => {
//   if (!process.env.REACT_APP_MOUSEFLOW_PROJECT_ID) return;

//   const head = document.getElementsByTagName("head")[0];
//   window._mfq = window._mfq || [];
//   var mf = document.createElement("script");
//   mf.id = "mouseflow-tracking-script";
//   mf.type = "text/javascript";
//   mf.defer = true;
//   mf.src = `//cdn.mouseflow.com/projects/${process.env.REACT_APP_MOUSEFLOW_PROJECT_ID}.js`;
//   if (isValidURL) {
//     head.appendChild(mf);
//   } else {
//     removeMouseflowScript();
//   }
// };

// export const removeMouseflowScript = () => {
//   const script = document.getElementById("mouseflow-tracking-script");
//   if (script) document.head.removeChild(script);
// };

// handle Clarity Script
export const addClarityScript = () => {
  if (!process.env.REACT_APP_CLARITY_SCRIPT_URL) return;
  if (document.getElementById("clarity-tracking-script")) return;
  window.clarity =
    window.clarity ||
    function() {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  const head = document.getElementsByTagName("head")[0];
  let clarityScript = document.createElement("script");
  clarityScript.id = "clarity-tracking-script";
  clarityScript.type = "text/javascript";
  clarityScript.async = true;
  clarityScript.src = process.env.REACT_APP_CLARITY_SCRIPT_URL;

  const firstScript = document.getElementsByTagName("script")[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(clarityScript, firstScript);
  } else {
    head.appendChild(clarityScript); // Fallback if no other scripts exist
  }
};

export const removeClarityScript = () => {
  // Remove the main script we added
  const script = document.getElementById("clarity-tracking-script");
  if (script && script.parentNode) {
    script.parentNode.removeChild(script);
  }

  // Remove all scripts injected by Clarity itself
  const allScripts = document.querySelectorAll('script[src*="clarity"]');
  allScripts.forEach(s => {
    if (s.parentNode) {
      s.parentNode.removeChild(s);
    }
  });

  // Clean up global objects
  if (window.clarity) {
    delete window.clarity;
  }
};

// handle hubspot script
export const addHubspotScript = () => {
  if (window.location.host !== "app.gunisms.com.au") return;
  if (document.getElementById("hs-script-loader")) return;

  const head = document.getElementsByTagName("head")[0];
  let hs1 = document.createElement("script");
  hs1.id = "hs-script-loader";
  hs1.type = "text/javascript";
  hs1.async = true;
  hs1.defer = true;
  hs1.src = "//js-na1.hs-scripts.com/24047932.js";

  let hs2 = document.createElement("script");
  hs2.id = "hs-script-loader";
  hs2.type = "text/javascript";
  hs2.async = true;
  hs2.defer = true;
  hs2.src = "//js.hs-scripts.com/24047932.js";

  head.appendChild(hs1);
  head.appendChild(hs2);
};

export const removeHubspotScript = () => {
  const script = document.getElementById("hs-script-loader");
  if (script) document.head.removeChild(script);
};

// handle live chat script
export const addLiveChatScript = () => {
  const script = `window.__lc = window.__lc || {};
    window.__lc.license = 12632517;
    (function (n, t, c) {
      function i(n) {
        return e._h ? e._h.apply(null, n) : e._q.push(n);
      }
      var e = {
        _q: [],
        _h: null,
        _v: "2.0",
        on: function () {
          i(["on", c.call(arguments)]);
        },
        once: function () {
          i(["once", c.call(arguments)]);
        },
        off: function () {
          i(["off", c.call(arguments)]);
        },
        get: function () {
          if (!e._h)
            throw new Error(
              "[LiveChatWidget] You can't use getters before load."
            );
          return i(["get", c.call(arguments)]);
        },
        call: function () {
          i(["call", c.call(arguments)]);
        },
        init: function () {
          var n = t.createElement("script");
          (n.async = !0),
            (n.type = "text/javascript"),
            (n.src = "https://cdn.livechatinc.com/tracking.js"),
            t.head.appendChild(n);
        },
      };
      !n.__lc.asyncInit && e.init(),
        (n.LiveChatWidget = n.LiveChatWidget || e);
    })(window, document, [].slice);
    `;

  if (document.getElementById("live-chat-script")) return;
  const head = document.getElementsByTagName("head")[0];
  const lc = document.createElement("script");
  lc.id = "live-chat-script";
  lc.type = "text/javascript";
  lc.appendChild(document.createTextNode(script));
  head.appendChild(lc);
};

export const removeLiveChatScript = () => {
  const script = document.getElementById("live-chat-script");
  if (script) {
    document.head.removeChild(script);
    delete window.__lc;
    delete window.LiveChatWidget;
  }
};

// handle Google Tag Manager
export const addGoogleTagManagerScript = () => {
  if (!process.env.GOOGLE_TAG_MANAGER_KEY) return;
  if (document.getElementById("gtm-script")) return;

  const head = document.getElementsByTagName("head")[0];

  // Check for IE or Edge and redirect if necessary
  if (window.document.documentMode) {
    window.location.href = "./UnsupportedBrowser.html";
  }

  const gtmScript = document.createElement("script");
  gtmScript.id = "gtm-script";
  gtmScript.type = "text/javascript";
  gtmScript.async = true;
  gtmScript.defer = true;
  gtmScript.text = `
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
      var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${process.env.GOOGLE_TAG_MANAGER_KEY}');
  `;
  head.appendChild(gtmScript);

  const gtmIframe = document.createElement("noscript");
  gtmIframe.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${process.env.GOOGLE_TAG_MANAGER_KEY}" height="0" width="0" style="display:none;visibility:hidden" loading="lazy"></iframe>
  `;
  document.body.appendChild(gtmIframe);
};

export const removeGoogleTagManagerScript = () => {
  const script = document.getElementById("gtm-script");
  if (script) document.head.removeChild(script);

  const iframe = document.querySelector('iframe[src*="googletagmanager.com/ns.html"]');
  if (iframe) document.body.removeChild(iframe);
};

// handle LinkedIn
export const addLinkedInScript = () => {
  if (document.getElementById("linkedin-script")) return;

  const linkedinScript = document.createElement("script");
  linkedinScript.id = "linkedin-script";
  linkedinScript.type = "text/javascript";
  linkedinScript.text = `
    _linkedin_partner_id = "6745108";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    (function(l) {
      if (!l) {
        window.lintrk = function(a, b) { window.lintrk.q.push([a, b]) };
        window.lintrk.q = [];
      }
      var s = document.getElementsByTagName("script")[0];
      var b = document.createElement("script");
      b.type = "text/javascript";
      b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      s.parentNode.insertBefore(b, s);
    })(window.lintrk);
  `;
  document.head.appendChild(linkedinScript);

  // Create LinkedIn noscript fallback
  const linkedinNoscript = document.createElement("noscript");
  linkedinNoscript.innerHTML = `
    <img height="1" width="1" style="display:none;" alt=""
      src="https://px.ads.linkedin.com/collect/?pid=6745108&fmt=gif" />
  `;
  document.body.appendChild(linkedinNoscript);
};

export const removeLinkedInScript = () => {
  const script = document.getElementById("linkedin-script");
  if (script) document.head.removeChild(script);

  const img = document.querySelector('img[src*="px.ads.linkedin.com/collect"]');
  if (img) document.body.removeChild(img);
};

export const addChatWidgetScript = () => {
  const head = document.getElementsByTagName("head")[0];

  const cssRules = `
    .lc_text-widget--bubble { display: none !important;}
    .lc_text-widget_prompt--prompt-text.without-avatar { display: none !important; }
    .lc_text-widget--prompt { display: none !important;}
  `;

  if (!document.getElementById("chat-widget-shadow-patch")) {
    const patchScript = document.createElement("script");
    patchScript.id = "chat-widget-shadow-patch";
    patchScript.type = "text/javascript";
    patchScript.text = `(function() {
      const originalAttachShadow = Element.prototype.attachShadow;
      Element.prototype.attachShadow = function(init) {
        const shadowRoot = originalAttachShadow.call(this, init);
        const style = document.createElement("style");
        style.textContent = \`${cssRules}\`;
        shadowRoot.prepend(style);
        return shadowRoot;
      };
    })();`;
    head.appendChild(patchScript);
  }

  if (!document.getElementById("chat-widget-style")) {
    const styleTag = document.createElement("style");
    styleTag.id = "chat-widget-style";
    styleTag.textContent = cssRules;
    head.appendChild(styleTag);
  }

  if (document.getElementById("chat-widget-script")) return;
  const chatScript = document.createElement("script");
  chatScript.id = "chat-widget-script";
  chatScript.type = "text/javascript";
  chatScript.src = "https://widgets.leadconnectorhq.com/loader.js";
  chatScript.setAttribute("data-resources-url", "https://widgets.leadconnectorhq.com/chat-widget/loader.js");
  chatScript.setAttribute("data-widget-id", "67d1069eb0f656e80e6c45bb");
  head.appendChild(chatScript);
};

export const removeChatWidgetScript = () => {
  try {
    const patchScript = document.getElementById("chat-widget-shadow-patch");
    if (patchScript) {
      document.head.removeChild(patchScript);
    }

    const styleTag = document.getElementById("chat-widget-style");
    if (styleTag) {
      document.head.removeChild(styleTag);
    }

    const chatScript = document.getElementById("chat-widget-script");
    if (chatScript) {
      document.head.removeChild(chatScript);
    }
  } catch (error) {
    console.error("Error removing chat widget script:", error);
  }
};

// handle Tawk.to chat widget
export const addTawkScript = (hide = true) => {
  if (document.getElementById("tawk-script")) return;

  // Initialize global vars as the original snippet does
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = window.Tawk_LoadStart || new Date();

  // Ensure the widget is hidden on load so it only opens when user triggers it
  if (hide) {
    try {
      if (!window.Tawk_API.__hideAttached) {
        const prevOnLoad = window.Tawk_API.onLoad;
        window.Tawk_API.onLoad = function() {
          try {
            prevOnLoad && prevOnLoad();
          } catch (e) {
            /* ignore */
          }
          try {
            if (typeof window.Tawk_API.hideWidget === "function") window.Tawk_API.hideWidget();
          } catch (err) {
            // ignore
          }
        };
        window.Tawk_API.__hideAttached = true;
      }
    } catch (e) {
      // ignore
    }
  }

  const s = document.createElement("script");
  s.id = "tawk-script";
  s.type = "text/javascript";
  s.async = true;
  s.src = "https://embed.tawk.to/68dde62af60d04194fced10b/1jbfab8p0";
  s.charset = "UTF-8";
  s.setAttribute("crossorigin", "*");

  const firstScript = document.getElementsByTagName("script")[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(s, firstScript);
  } else {
    // Fallback to append to head
    document.getElementsByTagName("head")[0].appendChild(s);
  }
};

// Programmatically open the Tawk widget (tries several API methods, falls back to clicking)
export const openTawkWidget = () => {
  if (!window.Tawk_API) {
    addTawkScript();
    // try again after a short delay
    setTimeout(openTawkWidget, 500);
    return;
  }

  try {
    if (typeof window.Tawk_API.maximize === "function") {
      window.Tawk_API.maximize();
      return;
    }
    if (typeof window.Tawk_API.toggle === "function") {
      window.Tawk_API.toggle();
      return;
    }
    if (typeof window.Tawk_API.showWidget === "function") {
      window.Tawk_API.showWidget();
      return;
    }

    // Fallback: look for Tawk iframe and try to click it
    const iframe = document.querySelector('iframe[src*="embed.tawk.to"]');
    if (iframe && iframe.contentWindow) {
      // dispatch a click event on the iframe's parent if possible
      const parent = iframe.parentNode;
      parent && parent.click && parent.click();
    }
  } catch (error) {
    console.error("Error opening Tawk widget:", error);
  }
};

// Set attributes (name/email/hash/id etc.) on the Tawk widget
export const setTawkAttributes = (user = {}) => {
  if (!user || (!user.name && !user.email && !user.id)) return;

  const attrs = {};
  if (user.name) attrs.name = user.name;
  if (user.email) attrs.email = user.email;
  if (user.id) attrs.id = user.id;
  if (user.hash) attrs.hash = user.hash;

  let attempts = 0;
  const maxAttempts = 10;

  const trySet = () => {
    attempts += 1;
    try {
      if (window.Tawk_API && typeof window.Tawk_API.setAttributes === "function") {
        window.Tawk_API.setAttributes(attrs, function(error) {
          if (error) console.error("Tawk setAttributes error:", error);
        });
        return;
      }

      // If Tawk is present but setAttributes not ready, attach to onLoad
      if (window.Tawk_API) {
        if (!window.Tawk_API.__attributesAttached) {
          const prev = window.Tawk_API.onLoad;
          window.Tawk_API.onLoad = function() {
            try {
              prev && prev();
            } catch (e) {
              /* ignore */
            }
            try {
              if (typeof window.Tawk_API.setAttributes === "function") {
                window.Tawk_API.setAttributes(attrs, function(error) {
                  if (error && error !== "RATE_LIMITED") console.error("Tawk setAttributes error:", error);
                });
              }
            } catch (err) {
              console.error("Error setting Tawk attributes onLoad:", err);
            }
          };
          window.Tawk_API.__attributesAttached = true;
        }
        return;
      }

      // If Tawk not present yet, inject script and retry
      if (attempts <= maxAttempts) {
        addTawkScript();
        setTimeout(trySet, 500 * attempts);
      } else {
        console.warn("Unable to set Tawk attributes after retries");
      }
    } catch (e) {
      console.error("Error while trying to setTawkAttributes:", e);
    }
  };

  trySet();
};

export const removeTawkScript = () => {
  try {
    // First, try to hide the widget via API if available
    if (window.Tawk_API && typeof window.Tawk_API.hideWidget === "function") {
      try {
        window.Tawk_API.hideWidget();
      } catch (e) {
        // ignore
      }
    }

    const script = document.getElementById("tawk-script");
    if (script && script.parentNode) script.parentNode.removeChild(script);

    // Remove any iframe or elements injected by Tawk
    const iframes = document.querySelectorAll('iframe[src*="embed.tawk.to"], iframe[src*="tawk.to"]');
    iframes.forEach(f => f.parentNode && f.parentNode.removeChild(f));

    // Remove all Tawk-related elements with various selectors
    const tawkSelectors = ['[id^="tawk"]', '[class*="tawk"]', ".tawk", '[id*="tawk-min"]', '[class*="widget-visible"]', 'div[style*="tawk"]'];

    tawkSelectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(e => e.parentNode && e.parentNode.removeChild(e));
      } catch (e) {
        // ignore selector errors
      }
    });

    // Clean up globals
    if (window.Tawk_API) delete window.Tawk_API;
    if (window.Tawk_LoadStart) delete window.Tawk_LoadStart;
  } catch (error) {
    console.error("Error removing Tawk script:", error);
  }
};
